import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import ProfileMenuLinks from './ProfileMenuLinks';
import ProfileMenuButton from './ProfileMenuButton';
import useClickOutside from '../../../hooks/useClickOutside';

const ProfileMenu = ({ profile }) => {
  const [expanded, setExpanded] = useState(false);
  const [focusedIndex, setFocusedIndex] = useState(null);
  const containerRef = useRef(null);
  useClickOutside(containerRef, expanded, () => setExpanded(false));

  return (
    <div
      ref={containerRef}
      data-testid="desktop-user-nav"
      className="vads-u-display--flex vads-u-justify-content--center user-nav vads-u-align-items--center"
    >
      <ProfileMenuButton
        profile={profile}
        expanded={expanded}
        setExpanded={setExpanded}
        setFocusedIndex={setFocusedIndex}
      />
      <div
        id="nav__user"
        className={`${
          !expanded ? 'vads-u-display--none' : 'is--shown'
        } nav__profile-menu`}
        data-testid="profile-menu-list"
      >
        <ul
          role="menu"
          id="nav__user-list"
          className={`nav__user-list nav__dropdown ${
            !expanded && 'vads-u-display--none'
          }`}
        >
          <ProfileMenuLinks
            profile={profile}
            closeMenu={() => setExpanded(false)}
            focusedIndex={focusedIndex}
            setFocusedIndex={setFocusedIndex}
          />
        </ul>
      </div>
    </div>
  );
};

ProfileMenu.propTypes = {
  profile: PropTypes.shape({
    firstName: PropTypes.string,
  }),
};

export default ProfileMenu;
